@if (this.cs | async; as cs) {
  <div class="request-container-4 request-content4-scrollable aa-scrollable-y aa-scrollbar"
    >
    <div class="request-content">
      <aa-cs-step1-summary [cs]="cs"></aa-cs-step1-summary>
      <aa-cs-step2-summary [cs]="cs"></aa-cs-step2-summary>
      <aa-cs-step3-summary [cs]="cs"></aa-cs-step3-summary>
      <aa-cs-step4-summary [cs]="cs"></aa-cs-step4-summary>
    </div>
  </div>
}
